Drupal.behaviors.offCanvas = {
  attach: (context) => {
    if (context === document) {
      /**
       * Determine the CSS transition time of a given element.
       *
       * This was refactored from Bootstrap's JavaScript.
       * @see {@link: https://github.com/twbs/bootstrap/blob/master/js/src/util/index.js#L57}
       *
       * @param {HTMLElement} element
       *   The element to extract the transition time from.
       *
       * @return {number}
       *   The calculated time of the elements transition.
       */
      const getTransitionTime = (element) => {
        // Return zero if no element was returned.
        if (!element) {
          return 0;
        }

        // Get CSS transition duration of the element.
        const {
          transitionDuration,
          transitionDelay,
        } = window.getComputedStyle(element);

        // Check if the transition has a valid value.
        if (!parseFloat(transitionDuration) && !parseFloat(transitionDelay)) {
          return 0;
        }

        // If multiple durations are defined, take the first
        const [duration] = transitionDuration.split(',');
        const [delay] = transitionDelay.split(',');

        // Add the duration to the delay and convert the result to seconds.
        return (parseFloat(duration) + parseFloat(delay)) * 1000;
      };

      /**
       * Closes the off canvas menu.
       */
      const close = () => {
        // Retrieve a jQuery instance of the backdrop.
        const $backdrop = $('#offcanvas-backdrop', context);

        // Determine the transition time of the backdrop.
        const transition = getTransitionTime($backdrop.get(0));

        // Hide the off canvas menu.
        $('.offcanvas-collapse', context).removeClass('open');
        // Hide the backdrop.
        $backdrop.removeClass('show');

        // Wait for the duration of the backdrop's transition and then remove
        // it from the DOM.
        setTimeout(() => {
          // Allow the ability to scroll.
          $('body', context).removeClass('overflow-hidden');
          $backdrop.remove();
        }, transition);
      };

      // Set up the off canvas menu toggle.
      $('[data-toggle="offcanvas"]', context).on('click', () => {
        // Check if the menu is already opened.
        if ($('.offcanvas-collapse', context).hasClass('open')) {
          // Close the menu if it is open.
          close();
        } else {
          // Open the off canvas menu.
          $('.offcanvas-collapse', context).toggleClass('open');

          // Create a Bootstrap modal backdrop.
          const div = document.createElement('div');
          // Add all appropriate backdrop classes.
          div.classList.add(
            'modal-backdrop',
            'fade',
          );
          // Give the backdrop an ID to allow for easy manipulation.
          div.setAttribute('id', 'offcanvas-backdrop');

          // Add the backdrop to the DOM and disabled the ability to scroll.
          $('body', context).append(div).addClass('overflow-hidden');

          const backdrop = document.getElementById('offcanvas-backdrop');

          setTimeout(() => {
            // Fade in the backdrop.
            $(backdrop).addClass('show');
          }, getTransitionTime(backdrop));
        }
      });

      // Close off canvas menu when clicking the backdrop.
      $(context).on('click', '#offcanvas-backdrop', close);
    }
  },
};
